import React from 'react';
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export default function Breadcrumb({
  crumb,
  icon,
  index,
  linkClassName,
  onClick,
  separator,
  separatorClassName,
  separatorIcon,
  focusable
}) {
  const {
    ref
  } = useFocusable({
    focusable,
    onEnterPress: onClick,
    forceFocus: true
  });
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsxs("button", {
      ref: ref,
      type: "button",
      title: crumb.tooltip,
      className: linkClassName,
      onClick: onClick,
      children: [icon, " ", crumb.name]
    }), typeof separator === 'function' ? separator(crumb, index) : separatorIcon == null ? /*#__PURE__*/_jsx("div", {
      className: separatorClassName,
      children: separator || '>'
    }) : /*#__PURE__*/_jsx("div", {
      className: separatorClassName,
      children: /*#__PURE__*/_jsx("i", {
        className: separatorIcon
      })
    })]
  });
}